import { AgentSource } from "../types/AgentSource";
import { Country } from "../types/Country";

function fetchAdmitCountries(baseUrl: string): Promise<Country[]> {
  const url = new URL(`${baseUrl}/webservices/public/index.cfm/country`);
  return fetch(url.toString()).then((response) => response.json());
  // .then((data) => {
  //   return data.map((country: any) => );
  // });
}

function fetchCaptureCountries(baseUrl: string): Promise<Country[]> {
  const url = new URL(`${baseUrl}/api/agent_widget/v1/countries`);
  return fetch(url.toString()).then((response) => response.json());
  // .then((data) => {
  //   return data.map((country: any) => );
  // });
}

export function fetchCountries(
  source: AgentSource,
  baseUrl: string,
): Promise<Country[]> {
  switch (source) {
    case "admit":
      return fetchAdmitCountries(baseUrl);
    case "capture":
      return fetchCaptureCountries(baseUrl);
  }
}
